import React, { useState } from "react";

const THEMES = [
  { id: "deep_focus",    name: "Deep Focus",    tagline: "Dark walls. Warm lamp. Still.",      wall: "#2A2A35", floor: "#3A2A1A", accent: "#C8A040", light: "#FFB060", dark: true  },
  { id: "golden_hour",   name: "Golden Hour",   tagline: "Warm whites. Amber light. Cozy.",    wall: "#F5EDD8", floor: "#A8784A", accent: "#C8A040", light: "#FFD060", dark: false },
  { id: "creative_flow", name: "Creative Flow", tagline: "Bold. Bright. Energizing.",          wall: "#F0EEEA", floor: "#D4C4A8", accent: "#E84878", light: "#FFF5E0", dark: false },
  { id: "calm",          name: "Calm",          tagline: "Sage. Soft light. Botanical.",       wall: "#B8C9A8", floor: "#6B8B6A", accent: "#4DB8B5", light: "#E0F8F0", dark: false },
  { id: "midnight",      name: "Midnight",      tagline: "Near black. Neon teal. Moody.",      wall: "#1A1A2E", floor: "#111118", accent: "#4DB8B5", light: "#40F0C0", dark: true  },
  { id: "fresh_start",   name: "Fresh Start",   tagline: "Clean white. Cool daylight. Crisp.", wall: "#F8F8F6", floor: "#E8E4DC", accent: "#1A1A1A", light: "#C0DCFF", dark: false },
];

// Each theme: array of swatches with position, size, rotation, texture
const LAYOUTS = {
  deep_focus: [
    { color:"#2A2A35", label:"Charcoal",  tex:"linen",   w:180, h:140, x:18,  y:22,  rot:-3  },
    { color:"#3A2A1A", label:"Walnut",    tex:"wood",    w:110, h:170, x:165, y:10,  rot:2   },
    { color:"#C8A040", label:"Brass",     tex:"metal",   w:130, h:100, x:48,  y:130, rot:-2  },
    { color:"#1E1E28", label:"Slate",     tex:"stone",   w:100, h:120, x:260, y:80,  rot:3   },
    { color:"#FFB060", label:"Amber",     tex:"plain",   w:80,  h:80,  x:220, y:160, rot:-4, circle:true },
  ],
  golden_hour: [
    { color:"#F5EDD8", label:"Plaster",   tex:"plaster", w:175, h:145, x:20,  y:18,  rot:2   },
    { color:"#A8784A", label:"Oak",       tex:"wood",    w:105, h:175, x:168, y:8,   rot:-3  },
    { color:"#E8D8B8", label:"Linen",     tex:"linen",   w:135, h:95,  x:40,  y:135, rot:3   },
    { color:"#C8A040", label:"Brass",     tex:"metal",   w:95,  h:115, x:258, y:75,  rot:-2  },
    { color:"#FFD060", label:"Amber",     tex:"plain",   w:85,  h:85,  x:215, y:158, rot:4,  circle:true },
  ],
  creative_flow: [
    { color:"#F0EEEA", label:"Chalk",     tex:"plaster", w:170, h:140, x:22,  y:20,  rot:-2  },
    { color:"#E84878", label:"Coral",     tex:"plain",   w:108, h:168, x:162, y:10,  rot:3   },
    { color:"#D4C4A8", label:"Sand",      tex:"linen",   w:130, h:98,  x:45,  y:132, rot:2   },
    { color:"#3848D8", label:"Cobalt",    tex:"plain",   w:98,  h:118, x:255, y:72,  rot:-3  },
    { color:"#F5A020", label:"Saffron",   tex:"plain",   w:88,  h:88,  x:218, y:155, rot:-5, circle:true },
  ],
  calm: [
    { color:"#B8C9A8", label:"Sage",      tex:"plaster", w:172, h:142, x:20,  y:20,  rot:3   },
    { color:"#6B8B6A", label:"Moss",      tex:"stone",   w:108, h:172, x:164, y:8,   rot:-2  },
    { color:"#D8E4C8", label:"Mist",      tex:"linen",   w:132, h:96,  x:44,  y:134, rot:-3  },
    { color:"#4DB8B5", label:"Teal",      tex:"plain",   w:96,  h:116, x:257, y:74,  rot:2   },
    { color:"#E0F8F0", label:"Dew",       tex:"plain",   w:82,  h:82,  x:217, y:157, rot:4,  circle:true },
  ],
  midnight: [
    { color:"#1A1A2E", label:"Velvet",    tex:"linen",   w:178, h:143, x:18,  y:19,  rot:-3  },
    { color:"#111118", label:"Onyx",      tex:"stone",   w:106, h:173, x:166, y:9,   rot:2   },
    { color:"#4DB8B5", label:"Teal",      tex:"plain",   w:132, h:98,  x:46,  y:133, rot:2   },
    { color:"#9B8FE0", label:"Lavender",  tex:"plain",   w:98,  h:118, x:256, y:73,  rot:-4  },
    { color:"#40F0C0", label:"Glow",      tex:"plain",   w:84,  h:84,  x:219, y:156, rot:5,  circle:true },
  ],
  fresh_start: [
    { color:"#F8F8F6", label:"White",     tex:"plaster", w:174, h:141, x:21,  y:21,  rot:2   },
    { color:"#E8E4DC", label:"Ash Oak",   tex:"wood",    w:107, h:171, x:163, y:9,   rot:-3  },
    { color:"#C8D4E8", label:"Sky",       tex:"linen",   w:131, h:97,  x:43,  y:133, rot:-2  },
    { color:"#D0CCC4", label:"Concrete",  tex:"stone",   w:97,  h:117, x:254, y:75,  rot:3   },
    { color:"#1A1A1A", label:"Ink",       tex:"plain",   w:83,  h:83,  x:216, y:158, rot:-4, circle:true },
  ],
};

// ── Texture SVG fills ────────────────────────────────────────────
function textureFill(tex, id, color) {
  const uid = `${tex}_${id}_${color.replace("#","")}`;
  if (tex === "wood") return {
    defs: (
      <pattern id={uid} x="0" y="0" width="12" height="80" patternUnits="userSpaceOnUse">
        <rect width="12" height="80" fill={color}/>
        <path d="M0 10 Q6 14 12 10 Q6 6 0 10Z"  fill="rgba(255,255,255,0.18)"/>
        <path d="M0 30 Q6 34 12 30 Q6 26 0 30Z" fill="rgba(0,0,0,0.12)"/>
        <path d="M0 52 Q6 55 12 52 Q6 49 0 52Z" fill="rgba(255,255,255,0.14)"/>
        <path d="M0 70 Q6 73 12 70 Q6 67 0 70Z" fill="rgba(0,0,0,0.1)"/>
        <line x1="3"  y1="0" x2="3"  y2="80" stroke="rgba(255,255,255,0.09)" strokeWidth="0.8"/>
        <line x1="9"  y1="0" x2="9"  y2="80" stroke="rgba(0,0,0,0.08)"      strokeWidth="0.6"/>
      </pattern>
    ),
    fill: `url(#${uid})`,
  };
  if (tex === "linen") return {
    defs: (
      <pattern id={uid} x="0" y="0" width="6" height="6" patternUnits="userSpaceOnUse">
        <rect width="6" height="6" fill={color}/>
        <line x1="0" y1="0" x2="6" y2="0" stroke="rgba(255,255,255,0.28)" strokeWidth="0.7"/>
        <line x1="0" y1="3" x2="6" y2="3" stroke="rgba(0,0,0,0.1)"        strokeWidth="0.5"/>
        <line x1="0" y1="0" x2="0" y2="6" stroke="rgba(255,255,255,0.22)" strokeWidth="0.7"/>
        <line x1="3" y1="0" x2="3" y2="6" stroke="rgba(0,0,0,0.08)"       strokeWidth="0.5"/>
      </pattern>
    ),
    fill: `url(#${uid})`,
  };
  if (tex === "stone") return {
    defs: (
      <pattern id={uid} x="0" y="0" width="22" height="22" patternUnits="userSpaceOnUse">
        <rect width="22" height="22" fill={color}/>
        <circle cx="4"  cy="5"  r="3"   fill="rgba(0,0,0,0.14)"/>
        <circle cx="15" cy="3"  r="1.8" fill="rgba(255,255,255,0.14)"/>
        <circle cx="9"  cy="15" r="2.5" fill="rgba(0,0,0,0.1)"/>
        <circle cx="19" cy="14" r="1.5" fill="rgba(255,255,255,0.1)"/>
        <circle cx="3"  cy="18" r="1.2" fill="rgba(0,0,0,0.08)"/>
        <circle cx="18" cy="8"  r="1"   fill="rgba(255,255,255,0.08)"/>
      </pattern>
    ),
    fill: `url(#${uid})`,
  };
  if (tex === "plaster") return {
    defs: (
      <pattern id={uid} x="0" y="0" width="16" height="16" patternUnits="userSpaceOnUse">
        <rect width="16" height="16" fill={color}/>
        <circle cx="3"  cy="5"  r="2.5" fill="rgba(0,0,0,0.07)"/>
        <circle cx="11" cy="3"  r="1.8" fill="rgba(255,255,255,0.16)"/>
        <circle cx="7"  cy="12" r="2"   fill="rgba(0,0,0,0.06)"/>
        <circle cx="13" cy="11" r="1.2" fill="rgba(255,255,255,0.12)"/>
        <circle cx="2"  cy="13" r="1"   fill="rgba(0,0,0,0.05)"/>
      </pattern>
    ),
    fill: `url(#${uid})`,
  };
  if (tex === "metal") return {
    defs: (
      <pattern id={uid} x="0" y="0" width="5" height="5" patternUnits="userSpaceOnUse">
        <rect width="5" height="5" fill={color}/>
        <line x1="0" y1="1"   x2="5" y2="1"   stroke="rgba(255,255,255,0.35)" strokeWidth="0.6"/>
        <line x1="0" y1="2.5" x2="5" y2="2.5" stroke="rgba(0,0,0,0.12)"       strokeWidth="0.5"/>
        <line x1="0" y1="4"   x2="5" y2="4"   stroke="rgba(255,255,255,0.2)"  strokeWidth="0.4"/>
      </pattern>
    ),
    fill: `url(#${uid})`,
  };
  // plain
  return { defs: null, fill: color };
}

// ── Label color readable on swatch ──────────────────────────────
function labelColor(hex) {
  try {
    const [r,g,b] = [parseInt(hex.slice(1,3),16), parseInt(hex.slice(3,5),16), parseInt(hex.slice(5,7),16)];
    const lum = (0.299*r + 0.587*g + 0.114*b) / 255;
    return lum > 0.45 ? "rgba(0,0,0,0.5)" : "rgba(255,255,255,0.55)";
  } catch { return "rgba(255,255,255,0.5)"; }
}

// ── Moodboard SVG ────────────────────────────────────────────────
function Moodboard({ themeId, dark }) {
  const swatches = LAYOUTS[themeId] || LAYOUTS.golden_hour;
  const boardBg  = dark ? "#111118" : "#E8E2DA";

  // collect all defs
  const allDefs = [];
  const fills   = [];
  swatches.forEach((s, i) => {
    const { defs, fill } = textureFill(s.tex, `${themeId}_${i}`, s.color);
    if (defs) allDefs.push(<React.Fragment key={i}>{defs}</React.Fragment>);
    fills.push(fill);
  });

  return (
    <svg viewBox="0 0 380 270" xmlns="http://www.w3.org/2000/svg"
      className="w-full h-full block rounded-[10px]">
      <defs>{allDefs}</defs>

      {/* Board background */}
      <rect width="380" height="270" fill={boardBg}/>

      {/* Render swatches back to front */}
      {swatches.map((s, i) => {
        const cx = s.x + s.w / 2;
        const cy = s.y + s.h / 2;
        const lc = labelColor(s.color);
        const shadow = "drop-shadow(0px 6px 18px rgba(0,0,0,0.38))";

        if (s.circle) {
          const r = s.w / 2;
          return (
            <g key={i} transform={`rotate(${s.rot} ${cx} ${cy})`} style={{ filter: shadow }}>
              <circle cx={cx} cy={cy} r={r} fill={fills[i]}/>
              <text x={cx} y={cy + 4} textAnchor="middle"
                fontSize="9" fontWeight="600" fill={lc}
                fontFamily="DM Sans,sans-serif" letterSpacing="0.04em">
                {s.label.toUpperCase()}
              </text>
            </g>
          );
        }
        return (
          <g key={i} transform={`rotate(${s.rot} ${cx} ${cy})`} style={{ filter: shadow }}>
            <rect x={s.x} y={s.y} width={s.w} height={s.h} rx="6" fill={fills[i]}/>
            <text x={s.x + 10} y={s.y + s.h - 10}
              fontSize="9" fontWeight="600" fill={lc}
              fontFamily="DM Sans,sans-serif" letterSpacing="0.05em">
              {s.label.toUpperCase()}
            </text>
          </g>
        );
      })}
    </svg>
  );
}

// ── Main component ───────────────────────────────────────────────
export default function PaintingPanel({ onClose, onThemeChange, activeThemeId }) {
  const [selected,   setSelected]   = useState(activeThemeId || "golden_hour");
  const [fading,     setFading]     = useState(false);
  const [savedFlash, setSavedFlash] = useState(false);

  const theme = THEMES.find(t => t.id === selected) || THEMES[1];

  const handleSelect = (id) => {
    if (id === selected) return;
    setFading(true);
    setTimeout(() => { setSelected(id); setFading(false); }, 150);
  };

  const apply = () => {
    if (onThemeChange) onThemeChange(selected);
    setSavedFlash(true);
    setTimeout(() => setSavedFlash(false), 2000);
  };

  return (
    <div className="flex flex-col h-full w-full bg-[#F2EEE8] font-['DM_Sans'] overflow-hidden rounded-2xl">
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap" rel="stylesheet"/>

      {/* Header */}
      <div className="flex items-center justify-between px-[18px] py-[13px] border-b border-black/[0.08] flex-shrink-0">
        <div className="flex items-baseline gap-2">
          <span className="text-sm font-bold text-[#2A1A0A]">Painting</span>
          <span className="text-[11px] text-[#B0A090]">Set the mood</span>
        </div>
        <button onClick={onClose} className="bg-transparent border border-black/10 text-[#B0A090] rounded-[7px] px-[11px] py-[3px] cursor-pointer text-xs font-['DM_Sans']">✕</button>
      </div>

      {/* Theme name */}
      <div className="px-[18px] pt-3 pb-1.5 flex-shrink-0 transition-opacity duration-150 ease-linear"
        style={{ opacity: fading ? 0 : 1 }}>
        <div className="text-[15px] font-bold text-[#2A1A0A]">{theme.name}</div>
        <div className="text-[11px] text-[#B0A090] mt-0.5 tracking-[0.02em]">
          {theme.tagline}
        </div>
      </div>

      {/* Moodboard */}
      <div className="flex-1 px-[18px] pt-1 pb-2.5 min-h-0 transition-opacity duration-150 ease-linear"
        style={{ opacity: fading ? 0 : 1 }}>
        <div className="w-full h-full rounded-[10px] overflow-hidden shadow-[0_3px_16px_rgba(0,0,0,0.13)]">
          <Moodboard themeId={theme.id} dark={theme.dark}/>
        </div>
      </div>

      {/* Footer */}
      <div className="flex-shrink-0 px-[18px] pt-2 pb-3.5 border-t border-black/[0.07] flex flex-col gap-2">

        {/* Color dots */}
        <div className="flex gap-[5px] items-center">
          {[theme.wall, theme.floor, theme.accent, theme.light].map((c,i) => (
            <div key={i} className="w-[13px] h-[13px] rounded-full border border-black/[0.08] shadow-[0_1px_3px_rgba(0,0,0,0.1)]" style={{ background: c }}/>
          ))}
          <span className="flex-1"/>
          <span className="text-[10px] text-[#C0B0A0] italic">
            preview only until applied
          </span>
        </div>

        {/* Theme tabs */}
        <div className="flex gap-1.5">
          {THEMES.map(t => (
            <button key={t.id} onClick={() => handleSelect(t.id)} title={t.name}
              className="flex-1 h-[26px] rounded-md border-none cursor-pointer relative overflow-hidden outline-offset-1 transition-all duration-[140ms] ease-linear"
              style={{
                outline: selected === t.id ? "2px solid #4DB8B5" : "2px solid transparent",
                transform: selected === t.id ? "translateY(-1px)" : "none",
                boxShadow: selected === t.id ? "0 3px 8px rgba(0,0,0,0.18)" : "0 1px 3px rgba(0,0,0,0.1)"
              }}>
              <div className="absolute top-0 left-0 right-0 h-[58%]" style={{ background: t.wall }}/>
              <div className="absolute bottom-0 left-0 right-0 h-[42%]" style={{ background: t.floor }}/>
              <div className="absolute top-[56%] left-0 right-0 h-0.5" style={{ background: t.accent }}/>
            </button>
          ))}
        </div>

        {/* Apply */}
        <button onClick={apply} className="w-full px-2.5 py-2.5 rounded-[9px] border-none cursor-pointer text-[13px] font-bold font-['DM_Sans'] transition-all duration-200 tracking-[0.01em]"
          style={{
            background: savedFlash ? "rgba(34,197,94,0.12)" : "#2A1A0A",
            color: savedFlash ? "#16A34A" : "#F5F0E8"
          }}>
          {savedFlash ? "✓ Applied to room" : "Apply to room"}
        </button>
      </div>
    </div>
  );
}
